import React, { useState } from "react";
import VendorDetailsPopup from "./VendorDetailsPopup";
import CustomTooltip from "../../components/CustomTooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faEye, faTrash } from "@fortawesome/free-solid-svg-icons";

const VendorActionButton = ({
  id,
  org,
  setEdit,
  setVendorId,
  toggleShowAddEditVendor,
  trustId,
  vendor,
  toggleShowDelete,
  used,
}) => {
  const [showView, setShowView] = useState(false);

  const toggleShowModal = () => {
    setShowView(!showView);
  };
  return (
    <>
      <span className="flex items-center gap-2 justify-center">
        <CustomTooltip message={"View"}>
          <span>
            <FontAwesomeIcon
              onClick={toggleShowModal}
              icon={faEye}
              size="1x"
              data-toggle="modal"
              data-target="#clientDetail"
            />
          </span>
        </CustomTooltip>
        {/* {!org && ( */}
          <>
            <span>/</span>
            <CustomTooltip message={"Edit"}>
              <span>
                <FontAwesomeIcon
                  icon={faEdit}
                  size="1x"
                  onClick={() => {
                    setEdit(true);
                    toggleShowAddEditVendor();
                    setVendorId(id);
                  }}
                />
              </span>
            </CustomTooltip>
          </>
        {/* )} */}
        {used ? (
          <></>
        ) : (
          <>
            <span>/</span>
            <CustomTooltip message={"Delete"}>
              <span>
                <FontAwesomeIcon
                  icon={faTrash}
                  size="1x"
                  onClick={() => {
                    setVendorId(id);
                    toggleShowDelete();
                  }}
                />
              </span>
            </CustomTooltip>
          </>
        )}
      </span>

      {showView && (
        <VendorDetailsPopup
          showView={showView}
          vendorId={id}
          org={org}
          toggleShowModal={toggleShowModal}
          setShowView={setShowView}
          trustId={trustId}
          vendor={vendor}
        />
      )}
    </>
  );
};

export default VendorActionButton;
